import React, { useState } from 'react';
import axios from 'axios';

const NewStaffForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    title: '',
    bio: '',
    picture: null,
    isProvider: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'file') {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData(prevState => ({
          ...prevState,
          [name]: reader.result.split(',')[1] // Get base64 string without metadata
        }));
      };
      reader.readAsDataURL(files[0]);
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // console.log('Sending data:', JSON.stringify(formData, null, 2));
  
    try {
      const response = await axios.post('https://01s8aky6al.execute-api.us-east-2.amazonaws.com/dev/admin', formData, {
        headers: { 'Content-Type': 'application/json' }
      });
      // console.log('Staff added successfully:', response.data);
      // Reset form or show success message
    } catch (error) {
      console.error('Error adding staff:', error.response?.data || error.message);
      // Show error message
    }
  };

  return (
    <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
      <h2 className="text-white text-2xl">Add New Staff Member</h2>
      <h3 className="text-white mb-6">❗ Staff photos must be under 5.5 megabytes</h3>
      <h3 className="text-white mb-6">❗ Refresh page to see changes in edit staff section.</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-white mb-2" htmlFor="name">Name</label>
          <input 
            type="text" 
            id="name"
            name="name" 
            value={formData.name} 
            onChange={handleChange} 
            className="w-full p-2 rounded bg-white text-black" 
            required 
          />
        </div>
        <div>
          <label className="block text-white mb-2" htmlFor="title">Title</label>
          <input 
            type="text" 
            id="title"
            name="title" 
            value={formData.title} 
            onChange={handleChange} 
            className="w-full p-2 rounded bg-white text-black" 
            required 
          />
        </div>
        <div>
          <label className="block text-white mb-2" htmlFor="bio">Bio (for providers)</label>
          <textarea 
            id="bio"
            name="bio" 
            value={formData.bio} 
            onChange={handleChange} 
            className="w-full p-2 rounded bg-white text-black h-32" 
          />
        </div>
        <div>
          <label className="block text-white mb-2" htmlFor="picture">Picture</label>
          <input 
            type="file" 
            id="picture"
            name="picture" 
            onChange={handleChange} 
            accept="image/*" 
            className="w-full p-2 rounded bg-white text-black" 
            required
          />
        </div>
        <div className="flex items-center">
          <input 
            type="checkbox" 
            id="isProvider"
            name="isProvider" 
            checked={formData.isProvider} 
            onChange={handleChange} 
            className="mr-2"
          />
          <label className="text-white" htmlFor="isProvider">Is this a provider?</label>
        </div>
        <button 
          type="submit" 
          className="w-full mt-4 p-2 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
        >
          Add Staff Member
        </button>
      </form>
    </div>
  );
};

export default NewStaffForm;
